const baseRoute = '/ap-pricing'

export const ApPricingAreaRoutes = {
  route: baseRoute,
  path: '/',
}
